module.exports = __webpack_public_path__ + "img/iq.82593c52.svg";